// Deal names (VAT treatments) pulled from MirageFirm4.DealName.
// English-translated labels for the demo dropdown.
export interface DealNameFixture {
  id: number
  vat_rate: number
  transaction_type: string
  description: string
  vat_code?: string
}

export const dealNamesFixture: DealNameFixture[] = [
  { id: 1, vat_rate: 20, transaction_type: 'sale', description: 'Taxable supply within the country - 20%' },
  { id: 2, vat_rate: 20, transaction_type: 'sale', description: 'Taxable intra-community acquisition - 20%' },
  { id: 3, vat_rate: 20, transaction_type: 'sale', description: 'VAT on goods/services for personal use' },
  { id: 4, vat_rate: 0, transaction_type: 'sale', description: 'Zero-rated supplies under Ch. III VAT Act' },
  { id: 5, vat_rate: 0, transaction_type: 'sale', description: 'Intra-community supply of goods - 0%' },
  { id: 6, vat_rate: 0, transaction_type: 'sale', description: 'Supplies under art. 140, 146, 173 - 0%' },
  { id: 7, vat_rate: 0, transaction_type: 'sale', description: 'Supply of services under art. 21(2)' },
  { id: 8, vat_rate: 0, transaction_type: 'sale', description: 'Supplies with place of execution in another EU member state' },
  { id: 9, vat_rate: 0, transaction_type: 'sale', description: 'Exempt supplies and exempt intra-community acquisitions - 0%' },
  { id: 10, vat_rate: 0, transaction_type: 'sale', description: 'Triangular operations as intermediary - 0%' },
  { id: 12, vat_rate: 20, transaction_type: 'purchase', description: 'Self-charged VAT under art. 82(2)-(5) - 20%' },
  { id: 13, vat_rate: 9, transaction_type: 'sale', description: 'Taxable supplies at 9% rate' },
  { id: 14, vat_rate: 0, transaction_type: 'purchase', description: 'Purchases without right to tax credit' },
  { id: 15, vat_rate: 20, transaction_type: 'purchase', description: 'Purchases with full right to tax credit - 20%' },
  { id: 16, vat_rate: 20, transaction_type: 'purchase', description: 'Purchases with partial right to tax credit - 20%' },
  { id: 18, vat_rate: 9, transaction_type: 'purchase', description: 'Purchases with full right to tax credit - 9%' },
  { id: 24, vat_rate: 0, transaction_type: 'purchase', description: 'Purchases with full tax credit under art. 82 - 0%' },
  { id: 37, vat_rate: 0, transaction_type: 'sale', description: 'Services under art. 21(6)' },
  { id: 38, vat_rate: 20, transaction_type: 'sale', description: 'Other taxable supplies - 20%' },
]
